import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core'
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap'
import { BootstrapService } from '../../vendors/bootstrap.service'

@Component({
    selector: 'app-drawer',
    templateUrl: './drawer.component.html',
    styleUrls: ['./drawer.component.scss'],
    host: {
        'class': 'h-100 col-auto position-md-relative position-absolute',
        'style': 'z-index: 990', // bootstrap's overlay z-index scale starts at 1000 for dropdown, we need header dropdowns to be above drawer, so we use 990 for drawer
    },
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DrawerComponent {
  isDrawerCollapsed = false
  @ViewChild('collapse', { 'static': false }) collapse: NgbCollapse

  // To control drawer use this in parent element
  // @ViewChild('drawer', { 'static': false }) drawer: DrawerComponent

  constructor (
    private bootstrapService: BootstrapService,
  ) {}

  closeIfSmallScreen (): void {
    if (window.innerWidth < this.bootstrapService.getBreakpoint('md')) {
      this.collapse.toggle(false)
    }
  }
}
